<template>
    <tr>
        <th>{{ $translate('pros', 'Fördelar') }}</th>
        <td v-for="card in allCards" :key="`${card.id}`">
            <ul>
                <li v-for="(item, index) in getPros(card)" :key="index">
                    <i class="fas fa-check-circle check-mark" />
                    <span>{{ item }}</span>
                </li>
            </ul>    
        </td>
    </tr>
</template>
<script>
export default {
    props: {
        allCards: {
            type: Array,
            required: true
        }
    },
    methods: {
        getPros(card) {
            return card.data.pros_condensed
                .filter((item) => item.pro && item.pro[0]?.text)
                .map((item) => item.pro[0].text);
        }
    }
};
</script>